var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomeLayout',{attrs:{"sidebarClasss":"sidebar-garden-help","url_base":_vm.url_base,"logo":_vm.logo,"sidebar_items":_vm.admin_sidebar_items,"logout_default_icon":_vm.logout_default_icon,"logout_active_icon":_vm.logout_active_icon}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32b19c66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/projects/garden_help/ContractorHome.vue
// module id = null
// module chunks = 